import { useEffect, useState } from "react";

const useNodeId = (): number | null => {
  const [nodeId, setNodeId] = useState<number | null>(null);

  useEffect(() => {
    const nodeIdInput = document.querySelector(`input[name="id_node_current"]`);
    if (nodeIdInput) {
      const id = parseInt((nodeIdInput as HTMLInputElement).value);
      if (!isNaN(id)) setNodeId(id);
    }
  }, []);

  return nodeId;
};

export default useNodeId;
